"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackNotifications = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var notificationTypes = [_reactSdk.HMSNotificationTypes.TRACK_ADDED, _reactSdk.HMSNotificationTypes.TRACK_REMOVED, _reactSdk.HMSNotificationTypes.TRACK_MUTED, _reactSdk.HMSNotificationTypes.TRACK_UNMUTED];
var TrackNotifications = function TrackNotifications() {
  var notification = (0, _reactSdk.useHMSNotifications)(notificationTypes);
  (0, _react.useEffect)(function () {
    if (notification) {
      console.debug("[".concat(notification.type, "]"), notification);
    }
  }, [notification]);
  return null;
};
exports.TrackNotifications = TrackNotifications;